<header class="top-header">
    <div class="header-left">
        @if (showMenuToggle) {
            <button
                mat-icon-button
                (click)="onMenuToggle()"
                class="menu-toggle hamburger-menu"
                [class.menu-collapsed]="isCollapsed"
                [class.mobile-menu]="isMobile"
            >
                <mat-icon>menu</mat-icon>
            </button>
        }

        <app-language-toggle></app-language-toggle>
    </div>

    <div class="header-right">
        <div class="header-actions">
            <app-header-notifications-bell class="header-notifications-bell"></app-header-notifications-bell>

            <div class="d-flex d-xl-none flex-row justify-content-center align-items-center mx-2 mobile-actions">
                @if (ratoeiraHubUrl) {
                    <button
                        mat-icon-button
                        (click)="goToRatoeiraHub()"
                        [matTooltip]="'menu.header.backToHub' | transloco"
                        class="mobile-icon-btn"
                    >
                        <mat-icon>home_work</mat-icon>
                    </button>
                }

                <app-theme-switcher
                    buttonClass="mobile-icon-btn theme-toggle-btn"
                    [showTooltip]="false"
                ></app-theme-switcher>

                <button
                    mat-stroked-button
                    (click)="onToggleAi()"
                    [matTooltip]="'menu.header.askAi' | transloco"
                    class="mobile-icon-btn ai-highlight-btn"
                >
                    <mat-icon>auto_awesome</mat-icon>
                </button>

                <button
                    mat-stroked-button
                    (click)="onOpenTutorial()"
                    [matTooltip]="'menu.header.helpCenter' | transloco"
                    class="mobile-icon-btn"
                >
                    <mat-icon>school</mat-icon>
                </button>
            </div>

            <div class="d-none d-xl-flex desktop-actions flex-row mx-2 justify-content-center align-items-center gap-2">
                @if (ratoeiraHubUrl) {
                    <button
                        mat-stroked-button
                        (click)="goToRatoeiraHub()"
                        [matTooltip]="'menu.header.backToHub' | transloco"
                        matTooltipPosition="left"
                        class="d-flex flex-row mr-2"
                    >
                        <mat-icon>home_work</mat-icon>
                        <span>{{ 'menu.header.backToHub' | transloco }}</span>
                    </button>
                }

                <app-theme-switcher buttonClass="theme-toggle-btn"></app-theme-switcher>

                <button
                    mat-stroked-button
                    (click)="onToggleAi()"
                    [matTooltip]="'menu.header.askAi' | transloco"
                    matTooltipPosition="left"
                    class="d-flex flex-row mr-2 ai-highlight-btn"
                >
                    <mat-icon>auto_awesome</mat-icon>
                    <span>{{ 'menu.header.askAi' | transloco }}</span>
                </button>

                <button
                    mat-stroked-button
                    (click)="onOpenTutorial()"
                    [matTooltip]="'menu.header.helpCenter' | transloco"
                    matTooltipPosition="left"
                    class="d-flex flex-row"
                >
                    <mat-icon>school</mat-icon>
                    <span>{{ 'menu.header.helpCenter' | transloco }}</span>
                </button>
            </div>

            <div class="d-flex flex-row mx-2 justify-content-center align-items-center gap-2">
                <app-impersonation-chip></app-impersonation-chip>

                <div class="user-info">
                    <span class="user-name">{{ nomeCliente || ('menu.header.user' | transloco) }}</span>
                </div>

                <div class="menu-div-menu-button">
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                    </button>

                    <mat-menu #menu="matMenu" class="v2-shell-header-menu">
                        @for (item of accountMenuItems; track item.labelKey) {
                            <button class="menu-botao v2-menu-item" mat-menu-item (click)="item.action()">
                                <mat-icon
                                    class="icone-menu"
                                    [matTooltip]="item.labelKey | transloco"
                                    matTooltipPosition="right"
                                    >{{ item.icon }}
                                </mat-icon>
                                <span class="ml-3 v2-menu-label">{{ item.labelKey | transloco }}</span>
                            </button>
                        }
                        @if (isStaffSession) {
                            <button class="menu-botao v2-menu-item" mat-menu-item (click)="openAdmin()">
                                <mat-icon
                                    class="icone-menu"
                                    [matTooltip]="'menu.userMenu.admin' | transloco"
                                    matTooltipPosition="right"
                                    >admin_panel_settings
                                </mat-icon>
                                <span class="ml-3 v2-menu-label">{{ 'menu.userMenu.admin' | transloco }}</span>
                            </button>
                        }
                        <button class="menu-botao v2-menu-item" mat-menu-item (click)="sair()">
                            <mat-icon
                                class="icone-menu"
                                [matTooltip]="'menu.userMenu.logout' | transloco"
                                matTooltipPosition="right"
                                >logout
                            </mat-icon>
                            <span class="ml-3 v2-menu-label">{{ 'menu.userMenu.logout' | transloco }}</span>
                        </button>
                    </mat-menu>
                </div>
            </div>
        </div>
    </div>
</header>
